import { useFocusEffect } from "expo-router";
import { useCallback, useState } from "react";

export function useToday() {
  const [today, setToday] = useState(new Date().toISOString());

  useFocusEffect(
    useCallback(() => {
      setToday(new Date().toISOString());
    }, []),
  );

  return today;
}
